<template>
    <b-modal v-model="urlModal" title="Link URL" @ok="handleOk">
        <b-container fluid>
            <b-form-input v-model="url" placeholder="Enter URL"></b-form-input>
        </b-container>
    </b-modal>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            url: null,
        }
    },

    computed: {
        urlModal: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },

    },
    methods: {
        handleOk() {
            this.$emit('set-url', this.url)
            this.urlModal = false;
        },
    },
}
</script>

<style scoped></style>
